// src/hooks/useSessionState.js
import { useState, useEffect } from 'react';

export default function useSessionState(key, defaultValue) {
  // Read from sessionStorage (or fall back to defaultValue)
  const [value, setValue] = useState(() => {
    try {
      const json = sessionStorage.getItem(key);
      return json != null ? JSON.parse(json) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  // Whenever it changes, write it back
  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {}
  }, [key, value]);

  return [value, setValue];
}
